import { UseFormGetValues } from "react-hook-form/dist/types/form";
import { FieldValues } from "react-hook-form";

export enum SubcontractorField {
  ID = "AdnocId",
  COMPANY_ID = "CompanyNo",
  ARABIC_NAME = "CompanyNameAr",
  ENGLISH_NAME = "CompanyNameEn",
  CICPA_ID = "CicpaId",
  PHONE = "Phone",
  ADDCI = "Addci",
  UNIFIED_ID = "UnifiedId",
  TRADE_LICENSE_EXPIRY = "TradeLicenseExpiryDate",
  TRADE_LICENSE = "TradeLicense",
  TRADE_LICENSE_NUMBER = "TradeLicenseNumber",
  TRADE_LICENSE_FILE_NAME = "TradeLicenseFileName",
  TRADE_LICENSE_FILE_FORMAT = "TradeLicenseFileFormat",
}

export enum SubcontractorFieldLabel {
  COMPANY_ID = "Company ID",
  ARABIC_NAME = "Arabic Name",
  ENGLISH_NAME = "English Name",
  CICPA_ID = "CICPA ID",
  PHONE = "Telephone No",
  ADDCI = "Trade License Number",
  UNIFIED_ID = "Unified ID",
  TRADE_LICENSE_EXPIRY = "Trade license expiry date",
  TRADE_LICENSE = "Trade License",
}

export enum SubcontractorFieldSubLabel {
  ARABIC_NAME = "Please enter the Arabic name manually and avoid copy/paste",
}

export interface useSubcontractorFormOperationsProps {
  getValues: UseFormGetValues<FieldValues>;
  ownCompanyNo: string | number;
  contractorId: string | number;
  adcciMembershipNo: string | number;
  email: string;
  docTypeId: number;
}
